export default __webpack_public_path__ + "static/media/nishat.f1b57bd6.jpg";